import './formFieldError.scss';

const FormFieldError = ({ message, customCls = '' }: { message: string, customCls?: string }) => message ? (
  <h6 className={`edit-profile-form-error-msg ${customCls}`}>{message}</h6>
) : null;

export default FormFieldError;